import PhoneNumberField from './PhoneNumberField';

export { default as PhoneNumberCaption } from './components/PhoneNumberCaption';
export default PhoneNumberField;
